import { useEffect, useState, useCallback } from 'react';
import { Card, Button, CardHeader, Row, Col, CardBody } from 'reactstrap';
import Helper from '../../utilities/helper'
import { useNavigate } from "react-router-dom";
import { useFetchWrapper } from '../../hooks/useFetchWrapper';
import { clientConfig } from '../../utilities/configService';

interface IFleetsProps {
    title: string,
    subtitle?: string,
    noDataMessage?: string
}

interface IAssessment {
    fleetID: string,
    fleetName: string,
    fleetLastViewed: Date,
    recCreatedDate: Date,
    recUpdatedDate: Date,
    totalVehicleCount: number
}

export const MyFleets = ({ title, subtitle, noDataMessage }: IFleetsProps) => {
    const fetchWrapper = useFetchWrapper();

    const navigate = useNavigate();
    const [estimates, setEstimates] = useState([]);
    const applicationName = clientConfig?.APPLICATION_NAME || '';

    const getEstimates = useCallback(() => {
        fetchWrapper.get(`fleet/estimates/${applicationName}`)
            .then((data) => {
                setEstimates(data.estimateSummaries);
            });
    }, [applicationName]);

    useEffect(() => {
        getEstimates();
    }, [getEstimates]);

    return (
        <Card>
            <CardHeader>
                <Row>
                    <Col sm={6}>
                        <h4 className="css_heading bold mt-0">{title}</h4>
                    </Col>
                    <Col sm={6}>
                        {estimates && estimates.length > 0 &&
                            <Button className="hollowPos  blueBorder tertiaryButton iconRightArrowBlue text-nowrap" onClick={() => { navigate('/viewFleets') }}>View My Fleets</Button>
                        }
                    </Col>
                </Row>
                {estimates && estimates.length > 0 ? (
                     <>
                            {subtitle && subtitle !== "" ? (
                                <Row>
                                    <Col className="subtitle">
                                        {(subtitle && subtitle !== "") &&
                                            <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                                        }
                                    </Col>
                                </Row>
                            ) : ('')}
                        </>
                ) : (
                        <Row>
                            <Col className="subtitle">
                                <div dangerouslySetInnerHTML={{ __html: noDataMessage || "" }} />
                            </Col>
                        </Row>  
                )}
            </CardHeader>
            <CardBody>
                {estimates && estimates.length > 0 && estimates.map((item: IAssessment) => {
                    return (
                        <Row  key={item.fleetID}>
                            <Col>
                                <div className="bold itemTitle">{item.fleetName}</div>
                                {item.totalVehicleCount > 1 ? (
                                    <div className="itemDesc">{item.totalVehicleCount}&nbsp;vehicles</div>
                                ) : (
                                    <div className="itemDesc">{item.totalVehicleCount}&nbsp;vehicle</div>
                                )}
                                <div className="italic itemDate">Created:&nbsp;{Helper.formatAsShortDateTime(item.recCreatedDate)}</div>
                                <div className="italic itemDate documentRow">Last updated:&nbsp;{Helper.formatAsShortDateTime(item.recUpdatedDate)}</div>
                                <Button className="solidNeg tertiaryButton iconRightArrow text-nowrap" onClick={() => { navigate('/ViewEstimate/' + item.fleetID); }} disabled={!(item.totalVehicleCount > 0)}>VIEW ESTIMATE</Button>
                            </Col>
                        </Row>
                    );
                })}
            </CardBody>
        </Card>
    );
};
